var AMapMap = function () {

    var map = undefined;
    var markerClusterer = undefined; // 聚合工具

    var loaded = false; // 是否已经加载
    var drawingManager = false; // 画图工具
    var circleArray = [];
    var polygonArray = [];
    var polyLineArray = [];
    var markerArray = [];
    var clustererArray = [];
    var labelArray = [];

    var drawCallBack = undefined;

    var EarthRadiusKm = 6378.137; // WGS-84


    function removeElementFromArr(elements, id) {
        if (!elements) return;

        if (id) {
            const index = elements.findIndex(element => element.id === id);
            if (index !== -1) {
                map.remove(elements[index].overlay);
                elements.splice(index, 1);
            }
        } else {
            elements.forEach(element => map.remove(element.overlay));
            elements.length = 0;
        }
    }


    // 初始化聚合器（高德地图2.0规范）
    function initClusterer() {
        if (!map) return;
        
        // 如果已存在聚合器，先销毁
        if (markerClusterer) {
            markerClusterer = null;
        }

        // 创建聚合器，使用高德地图2.0配置
        markerClusterer = new AMap.MarkerClusterer(map, [], {
            gridSize: 80,                    // 聚合网格大小（像素）
            maxZoom: 15,                     // 最大聚合级别
            minClusterSize: 2,               // 最小聚合数量
            averageCenter: true,             // 聚合点使用所有标记的平均中心
            renderClusterMarker: function (context) {
                // 自定义聚合点样式
                var count = context.count;
                var size = Math.max(30, Math.min(50, 30 + count * 0.5));
                
                return new AMap.Marker({
                    position: context.center,
                    content: '<div style="background: #2a7aff; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; box-shadow: 0 2px 10px rgba(0,0,0,0.2);" style="width:' + size + 'px;height:' + size + 'px;line-height:' + size + 'px;">' + count + '</div>',
                    offset: new AMap.Pixel(-size/2, -size/2)
                });
            }
        });
    }

    this.showCluster = function () {
        if (map && !markerClusterer) {
            initClusterer();
        }
    }

    this.removeClustererById = function (id) {
        if (!loaded || !markerClusterer || !id) return;
        
        const index = clustererArray.findIndex(m => m.id === id);
        if (index !== -1) {
            // 高德地图2.0使用removeMarkers方法（数组参数）
            if (typeof markerClusterer.removeMarkers === 'function') {
                markerClusterer.removeMarkers([clustererArray[index].overlay]);
            }
            clustererArray.splice(index, 1);
        }
    };

    // 批量添加标记到聚合（高德地图2.0优化版）
    this.addMarkersToCluster = function (markersData) {
        if (!loaded) {
            console.warn('AMapMap: addMarkersToCluster called before map loaded');
            return;
        }
        if (!markersData || !Array.isArray(markersData) || markersData.length === 0) {
            return;
        }

        // 确保聚合器已初始化
        if (!markerClusterer) {
            initClusterer();
        }

        const newMarkers = [];

        for (let data of markersData) {
            const { id, name, lng, lat, iconUrl, callback } = data;

            if (lng == undefined || lat == undefined) continue;
            const markerId = id || "marker" + Date.now() + Math.random();
            const markerName = name || "marker";

            // 检查是否已存在相同id的marker，避免重复添加
            const existingIndex = clustererArray.findIndex(m => m.id === markerId);
            if (existingIndex !== -1) {
                // 如果已存在，先移除旧的marker（高德地图2.0使用removeMarkers方法）
                if (typeof markerClusterer.removeMarkers === 'function') {
                    markerClusterer.removeMarkers([clustererArray[existingIndex].overlay]);
                }
                clustererArray.splice(existingIndex, 1);
            }

            // 创建图标
            var myIcon = undefined;
            if (iconUrl) {
                myIcon = new AMap.Icon({
                    size: new AMap.Size(22, 32),
                    image: require("@/" + iconUrl),
                    imageSize: new AMap.Size(22, 32),
                    imageOffset: new AMap.Pixel(-10, -25)
                });
            }

            // 创建标记
            var marker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                icon: myIcon,
                title: markerName,
                id: markerId
            });

            // 添加点击事件
            if (callback) {
                marker.on("click", callback);
            }

            clustererArray.push({ id: markerId, overlay: marker });
            newMarkers.push(marker);
        }

        // 批量添加到聚合器（高德地图2.0使用addMarkers方法）
        if (newMarkers.length > 0 && typeof markerClusterer.addMarkers === 'function') {
            markerClusterer.addMarkers(newMarkers);
        }
    };

    // 清除所有聚合标记（高德地图2.0优化版）
    this.clearMarkerCluster = function () {
        if (!loaded) return;
        
        if (markerClusterer) {
            try {
                // 清除聚合器中的所有标记
                markerClusterer.clearMarkers();
            } catch (e) {
                console.warn('AMapMap: Failed to clear markers:', e);
            }
        }
        
        // 清理本地数组引用
        clustererArray.forEach(item => {
            try {
                item.overlay.setMap(null);
            } catch (e) {
                console.warn('AMapMap: Failed to remove marker from map:', e);
            }
        });
        clustererArray = [];
        
        // 重置聚合器（避免状态混乱）
        initClusterer();
    };

    this.addMarkerToCluster = function (id, name, lng, lat, iconUrl, callback) {
        if (!loaded) {
            console.warn('AMapMap: addMarkerToCluster called before map loaded');
            return;
        }
        if (lng == undefined || lat == undefined) return false;
        if (id == undefined || id == "") id = "marker0";
        if (name == undefined) name = "marker";

        // 确保聚合器已初始化
        if (!markerClusterer) {
            initClusterer();
        }

        // 创建图标
        var myIcon = undefined;
        if (iconUrl) {
            myIcon = new AMap.Icon({
                size: new AMap.Size(22, 32),
                image: require("@/" + iconUrl),
                imageSize: new AMap.Size(22, 32),
                imageOffset: new AMap.Pixel(-10, -25)
            });
        }

        // 创建标记
        var marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat),
            icon: myIcon,
            title: name,
            id: id
        });

        // 添加点击事件
        if (callback) {
            marker.on("click", callback);
        }

        // 添加到数组和聚合器（高德地图2.0使用addMarkers方法）
        clustererArray.push({ id: id, overlay: marker });
        if (typeof markerClusterer.addMarkers === 'function') {
            markerClusterer.addMarkers([marker]);
        }
        
        return marker;
    };

    /*
      opts = {
        center: [116.404, 39.915],中心点经纬度
        zoom: 12,缩放级别
        coordsType: 'gcj02', 坐标类型
        completed: function(){} 加载完成回调
      }
      */
    this.initMap = function (mapId, opts) {
        if (loaded || map !== undefined) {
            return Promise.resolve(map);
        }

        try {
            // 参数验证
            if (!mapId) {
                throw new Error('Map ID is required');
            }

            opts = opts || { coordsType: 'gcj02' };

            // 初始化地图
            map = new AMap.Map(mapId, {
                zoom: opts.zoom || 14,
                center: opts.center ? new AMap.LngLat(opts.center[0], opts.center[1]) : new AMap.LngLat(116.404, 39.915),
                zooms: [3, 18],
                resizeEnable: true
            });

            // 添加地图控件
            map.addControl(new AMap.ToolBar());

            // 初始化画图工具
            drawingManager = new AMap.MouseTool(map);
            drawingManager.on("draw", function (event) {
                switch (event.obj.className) {
                    case 'AMap.Marker':
                        if (drawCallBack)
                            drawCallBack(event.obj.getPosition().lng, event.obj.getPosition().lat);
                        // 启用拖拽功能，允许用户微调标记位置
                        event.obj.setDraggable(true);
                        event.obj.on('dragend', function () {
                            var pos = event.obj.getPosition();
                            if (drawCallBack) drawCallBack(pos.getLng(), pos.getLat());
                        });
                        break;
                    case 'Overlay.Polyline':
                        var path = event.obj.getPath();
                        var lonlats = "";
                        for (var i = 0; i < path.length; i++) {
                            if (lonlats != "") lonlats += ";";
                            lonlats += path[i].lng + "," + path[i].lat;
                        }
                        if (drawCallBack) drawCallBack(lonlats);
                        break;
                    case 'Overlay.Polygon':
                        var path = event.obj.getPath();
                        var lonlats = "";
                        for (var i = 0; i < path.length; i++) {
                            if (lonlats != "") lonlats += ";";
                            lonlats += path[i].getLng() + "," + path[i].getLat();
                        }
                        if (drawCallBack) drawCallBack(lonlats);
                        break;
                    case 'Overlay.Rectangle':
                        var bounds = event.obj.getBounds();
                        var sw = bounds.getSouthWest();
                        var ne = bounds.getNorthEast();
                        if (drawCallBack) drawCallBack(sw.getLng(), sw.getLat(), ne.getLng(), ne.getLat());
                        break;
                    case 'Overlay.Circle':
                        var center = event.obj.getCenter();
                        var radius = event.obj.getRadius();
                        if (drawCallBack) drawCallBack(center.getLng(), center.getLat(), radius);
                        break;
                }
                console.log("覆盖物对象绘制完成");
            });

            // 初始化聚合器
            initClusterer();

            // 监听地图加载完成事件
            const completeHandler = () => {
                if (!loaded) {
                    loaded = true;
                    if (opts.completed) {
                        opts.completed();
                    }
                }
            };

            // 立即检查是否已加载完成
            if (map.getStatus() === 'complete') {
                completeHandler();
            } else {
                map.on('complete', completeHandler);
            }

        } catch (error) {
            console.error('AMapMap: Failed to initialize AMap:', error);
            throw error;
        }
    };

    this.clearAll = function () {
        if (!loaded) return;
        
        map.clearMap();
        
        // 清空内部数组
        markerArray.length = 0;
        polyLineArray.length = 0;
        polygonArray.length = 0;
        circleArray.length = 0;
        clustererArray.length = 0;
        labelArray.length = 0;
        
        // 重置聚合器
        initClusterer();
    };

    this.setCenter = function (lng, lat) {
        if (!loaded) return;
        map.setCenter(new AMap.LngLat(lng, lat));
    };

    // 添加点（非聚合）
    this.addMarker = function (id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight, options) {
        if (!loaded) return;
        if (lng == undefined || lat == undefined) return false;
        if (id == undefined || id == "") id = "marker0";
        if (name == undefined) name = "marker";
        options = options || {};
        
        var myIcon = undefined;
        if (iconUrl) {
            iconWidth = iconWidth || 22;
            iconHeight = iconHeight || 32;
            myIcon = new AMap.Icon({
                size: new AMap.Size(iconWidth * 2, iconHeight),
                image: require("@/" + iconUrl),
                imageSize: new AMap.Size(iconWidth, iconHeight),
                imageOffset: new AMap.Pixel(0, 0)
            });
        }

        var marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat),
            icon: myIcon,
            title: name,
            draggable: options.draggable ? true : false
        });

        if (callback) marker.on("click", callback);

        map.add(marker);
        markerArray.push({ id: id, overlay: marker });

        // 添加对应的label
        var label = new AMap.Text({
            position: new AMap.LngLat(lng, lat),
            text: name,
            offset: new AMap.Pixel(-30, 10),
            style: {
                color: "#444444",
                fontSize: "13px",
                border: "1px solid #DDDDDD",
                backgroundColor: "#FFFFFF",
                padding: "3px"
            }
        });

        map.add(label);
        labelArray.push({ id: id, overlay: label });

        // 启用拖拽：拖动时同步更新 label 位置
        if (options.draggable) {
            marker.on('dragging', function () {
                var pos = marker.getPosition();
                label.setPosition(new AMap.LngLat(pos.getLng(), pos.getLat()));
            });
            if (options.onDragEnd) {
                marker.on('dragend', function () {
                    var pos = marker.getPosition();
                    label.setPosition(new AMap.LngLat(pos.getLng(), pos.getLat()));
                    options.onDragEnd(pos.getLng(), pos.getLat());
                });
            }
        }

        return marker;
    };

    // 添加线
    this.addPolyline = function (id, name, coordinators, width, color, isArrow) {
        if (!loaded) return;
        if (coordinators == undefined || coordinators == "") return false;
        if (id == undefined || id == "") id = "line0";
        if (name == undefined) name = "";
        width = width || 1;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        isArrow = isArrow || false;

        var path = [];
        for (var i = 0; i < coordinators.length; i++) {
            if (coordinators[i].lat != undefined && coordinators[i].lng) {
                path.push(new AMap.LngLat(coordinators[i].lng, coordinators[i].lat));
            }
        }

        var polyline = new AMap.Polyline({
            path: path,
            strokeColor: color,
            strokeWeight: width,
            strokeOpacity: 0.8,
            lineJoin: 'round',
            lineCap: 'round'
        });

        map.add(polyline);
        map.setFitView([polyline]);
        polyLineArray.push({ id: id, overlay: polyline });
    };

    this.removeMarkerById = function (id) {
        if (!loaded) return;
        removeElementFromArr(markerArray, id);
        removeElementFromArr(labelArray, id);
    };

    this.clearMarkers = function (id) {
        if (!loaded) return;
        removeElementFromArr(markerArray);
        removeElementFromArr(labelArray);
    };

    this.removePolylineById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polyLineArray, id);
    };

    this.removePolygonById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polygonArray, id);
    };

    this.removeCircleById = function (id) {
        if (!loaded) return;
        removeElementFromArr(circleArray, id);
    };

    // 添加多边形
    this.addPolygon = function (id, name, coordanites, strokeWidth, strokeColor, fillColor) {
        if (!loaded) return;
        if (coordanites == undefined || coordanites == "") return false;
        if (id == undefined || id == "") id = "region0";
        if (name == undefined) name = "";
        strokeWidth = strokeWidth || 1;

        var path = [];
        for (var i = 0; i < coordanites.length; i++) {
            path.push(new AMap.LngLat(coordanites[i].lng, coordanites[i].lat));
        }

        strokeColor = strokeColor || "#CD3700";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#CD3700";

        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        var polygon = new AMap.Polygon({
            path: path,
            strokeColor: strokeColor,
            strokeWeight: strokeWidth,
            strokeOpacity: 0.5,
            fillColor: fillColor,
            fillOpacity: 0.35
        });

        map.add(polygon);
        map.setFitView([polygon]);
        polygonArray.push({ id: id, overlay: polygon });
    };

    this.addCircle = function (id, lnglat, radius, strokeWidth, strokeColor, fillColor, isReCenter = true) {
        if (!loaded) return;
        if (lnglat == undefined || radius == undefined) return false;
        if (id == undefined || id == "") id = "circle0";
        strokeWidth = strokeWidth || 1;

        var center = new AMap.LngLat(lnglat.lng, lnglat.lat);
        strokeColor = strokeColor || "#CD3700";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        var circle = new AMap.Circle({
            center: center,
            radius: parseFloat(radius),
            strokeColor: strokeColor,
            fillColor: fillColor,
            fillOpacity: 0.35,
            strokeWeight: strokeWidth,
            strokeOpacity: 0.8
        });

        map.add(circle);
        if (isReCenter) {
            map.setFitView([circle]);
        }
        circleArray.push({ id: id, overlay: circle });
    };

    this.cancelDraw = function () {
        if (!loaded) return;
        map.clearMap();
        if (drawingManager) {
            drawingManager.close();
        }
    };

    this.drawPoint = function (callback) {
        if (!loaded) return;

        map.clearMap();
        drawCallBack = callback;
        drawingManager.marker();
    };

    this.drawRectangle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        map.clearMap();
        drawCallBack = callback;

        drawingManager.rectangle({
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: width,
            fillColor: fillColor,
            fillOpacity: 0.35,
            strokeStyle: 'solid',
        });
    };

    this.drawPolygon = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        map.clearMap();
        drawCallBack = callback;

        drawingManager.polygon({
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: width,
            fillColor: fillColor,
            fillOpacity: 0.35,
            strokeStyle: "solid",
        });
    };

    this.drawLine = function (width, color, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#0609D8";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#0609D8";

        map.clearMap();
        drawCallBack = callback;
        
        drawingManager.polyline({
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: width,
            strokeStyle: "solid",
        });
    };

    this.drawCircle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        map.clearMap();
        drawCallBack = callback;
        
        drawingManager.circle({
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: width,
            fillColor: fillColor,
            fillOpacity: 0.35,
            strokeStyle: 'solid',
        });
    };

    this.pointToLineDist = function (x1, y1, x2, y2, x0, y0) {
        var space = 0;
        var a, b, c;
        a = this.calcDistance(x1, y1, x2, y2);
        b = this.calcDistance(x1, y1, x0, y0);
        c = this.calcDistance(x2, y2, x0, y0);
        if (c <= 0.000001 || b <= 0.000001) {
            space = 0;
            return space;
        }
        if (a <= 0.000001) {
            space = b;
            return space;
        }
        if (c * c >= a * a + b * b) {
            space = b;
            return space;
        }

        if (b * b >= a * a + c * c) {
            space = c;
            return space;
        }

        var p = (a + b + c) / 2;
        var s = Math.sqrt(p * (p - a) * (p - b) * (p - c));
        space = (2 * s) / a;
        return space;
    };

    this.calcDistance = function (p1Lng, p1Lat, p2Lng, p2Lat) {
        var dLat1InRad = p1Lat * (Math.PI / 180);
        var dLong1InRad = p1Lng * (Math.PI / 180);
        var dLat2InRad = p2Lat * (Math.PI / 180);
        var dLong2InRad = p2Lng * (Math.PI / 180);
        var dLongitude = dLong2InRad - dLong1InRad;
        var dLatitude = dLat2InRad - dLat1InRad;
        var a = Math.pow(Math.sin(dLatitude / 2), 2) + Math.cos(dLat1InRad) * Math.cos(dLat2InRad) * Math.pow(Math.sin(dLongitude / 2), 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var dDistance = EarthRadiusKm * c;
        return dDistance * 1000;
    };

    // 定义一些常量
    var x_PI = (3.14159265358979324 * 3000.0) / 180.0;
    var PI = 3.1415926535897932384626;
    var a = 6378245.0;
    var ee = 0.00669342162296594323;

    /**
     * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
     * @param bd_lon
     * @param bd_lat
     * @returns {*[]}
     */
    function bd09togcj02(bd_lon, bd_lat) {
        var x_pi = (3.14159265358979324 * 3000.0) / 180.0;
        var x = bd_lon - 0.0065;
        var y = bd_lat - 0.006;
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
        var gg_lng = z * Math.cos(theta);
        var gg_lat = z * Math.sin(theta);
        return { lng: gg_lng, lat: gg_lat };
    }

    /**
     * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    function gcj02tobd09(lng, lat) {
        var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
        var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
        var bd_lng = z * Math.cos(theta) + 0.0065;
        var bd_lat = z * Math.sin(theta) + 0.006;
        return { lng: bd_lng, lat: bd_lat };
    }

    /**
     * WGS84转GCj02
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    function wgs84togcj02(lng, lat) {
        if (out_of_china(lng, lat)) {
            return { lng: lng, lat: lat };
        } else {
            var dlat = transformlat(lng - 105.0, lat - 35.0);
            var dlng = transformlng(lng - 105.0, lat - 35.0);
            var radlat = (lat / 180.0) * PI;
            var magic = Math.sin(radlat);
            magic = 1 - ee * magic * magic;
            var sqrtmagic = Math.sqrt(magic);
            dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
            dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
            var mglat = lat + dlat;
            var mglng = lng + dlng;
            return { lng: mglng, lat: mglat };
        }
    }

    /**
     * GCJ02 转换为 WGS84
     * @param lng
     * @param lat
     * @returns {*[]}
     */
    function gcj02towgs84(lng, lat) {
        if (out_of_china(lng, lat)) {
            return { lng: lng, lat: lat };
        } else {
            var dlat = transformlat(lng - 105.0, lat - 35.0);
            var dlng = transformlng(lng - 105.0, lat - 35.0);
            var radlat = (lat / 180.0) * PI;
            var magic = Math.sin(radlat);
            magic = 1 - ee * magic * magic;
            var sqrtmagic = Math.sqrt(magic);
            dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
            dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
            var mglat = lat + dlat;
            var mglng = lng + dlng;
            return { lng: lng * 2 - mglng, lat: lat * 2 - mglat };
        }
    }

    function transformlat(lng, lat) {
        var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
        ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
        ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
        ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
        return ret;
    }

    function transformlng(lng, lat) {
        var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
        ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
        ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
        ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
        return ret;
    }

    /**
     * 判断是否在国内，不在国内则不做偏移
     * @param lng
     * @param lat
     * @returns {boolean}
     */
    function out_of_china(lng, lat) {
        return (lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271 || false);
    }
};

export { AMapMap };